export default {"src":"/_next/static/media/clearviewai.c6122dbb.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};